<template>
  <th class="align-left" v-if="isHeader">
    {{ title }}
  </th>
  <div v-else-if="rowData">
    <span :class="getCssClasses(rowData.request)">
      <b>{{ getStatusString(rowData.request) }}</b> </span
    ><br />
  </div>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {request: {status: '-'}}
      },
    },
  },
  computed: {
    statusMap() {
      return {
        PENDING: {
          text: this.$t('appointments.status.PENDING'),
          css: 'orangebg',
        },
        ACCEPTED: {
          text: this.$t('appointments.status.ACCEPTED'),
          css: 'greenbg',
        },
        REJECTED: {
          text: this.$t('appointments.status.CANCELLED_USER'),
          css: 'redbg',
        },
        CANCELLED_ADMIN: {
          text: this.$t('appointments.status.CANCELLED_USER'),
          css: 'redbg',
        },
        CANCELLED_USER: {
          text: this.$t('appointments.status.CANCELLED_USER'),
          css: 'redbg',
        },
      }
    },
  },
  methods: {
    getStatusString(request) {
      let value = ''
      if (request && request.status) {
        value = this.statusMap[request.status] ? this.statusMap[request.status].text : ''
      }
      return value
    },
    getCssClasses(request) {
      let value = ''
      if (request && request.status) {
        value = this.statusMap[request.status] ? this.statusMap[request.status].css : ''
      }
      return 'f-s-15 uppercase ' + value
    },
  },
  name: 'Status',
}
</script>

<style scoped>
.uppercase {
  text-transform: uppercase;
}

.greenbg {
  color: green !important;
}

.redbg {
  color: red !important;
}

.orangebg {
  color: orange !important;
}
</style>
<style src="@/styles/styled_cell.less" lang="less" scoped="true"></style>
